import { updateObject } from "../../Utils/Utils";

import {
    SET_PAGE_PERPAGE
} from "../Action/MTableAction";

const initialState = {
    pages: []
}

const MTableReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PAGE_PERPAGE:
            var { pageName, page, perpage } = action;
            const { pages } = state;

            let _pages = JSON.parse(JSON.stringify(pages));

            const index = _pages.findIndex(e => e.pageName == pageName);
            if (index == -1) {
                if (pageName) {
                    _pages.push({
                        pageName,
                        page,
                        perpage
                    });
                }
            } else {
                _pages[index].page = page;
                _pages[index].perpage = perpage;
            }

            return { ...state, pages: _pages };
        default:
            return state;
    }
}

export default MTableReducer;